import styled from '@emotion/styled';
import { Flex, Text } from '@pairy/pds-react';
import { theme } from '@pairy/styles';

import PdfThumbImage from '../../@common/PdfThumbImage';

export const Panel = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-shrink: 0;
  background: ${theme.colors.white};

  ${({ isMobile }) =>
    isMobile
      ? `
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    height: 148px;
    padding: 12px 16px;
    overflow-x: auto;
    border-top: 1px solid ${theme.colors.zinc_200};
  `
      : `
    flex-direction: column;
    width: 200px;
    height: 100%;
    border-right: 1px solid ${theme.colors.zinc_200};
  `}
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 16px 16px 12px;
  border-bottom: 1px solid ${theme.colors.zinc_200};
  gap: 4px;
`;

export const PanelHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const PanelCloseButton = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_100};
  }
`;

export const PanelTitle = styled(Text)`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
`;

export const PanelScroll = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  gap: 12px;
  overflow-y: auto;
`;

export const Item = styled.button<{ isMobile: boolean }>`
  display: flex;
  max-width: 168px;
  flex-direction: column;
  flex-shrink: 0;
  ${({ isMobile }) => (isMobile ? 'width: auto;' : 'width: 100%;')}
  padding: 4px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  gap: 4px;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_100};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.skyblue_400};
    outline-offset: 2px;
  }

  &.is-current > div:first-of-type {
    border-color: ${theme.colors.skyblue_400};
  }
`;

export const ThumbBox = styled.div<{ isMobile: boolean }>`
  position: relative;
  /* NOTE: 데스크톱은 인라인 width(min(100%, 120px * 비율))로 페이지 비율을 유지한다
     — max-height로 높이만 잘리면 임베드 오버레이(% 좌표)가 어긋난다 */
  ${({ isMobile }) => (isMobile ? 'height: 96px;' : 'margin: 0 auto;')}
  overflow: hidden;
  border: 2px solid ${theme.colors.zinc_200};
  background: ${theme.colors.zinc_100};
  border-radius: 6px;
  transition: 0.15s ease-in-out;
`;

export const PanelThumbImage = styled(PdfThumbImage)`
  &.is-blind {
    filter: blur(6px);
  }
`;

export const LegacyThumbImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;

  user-select: none;

  &.is-blind {
    filter: blur(6px);
  }
`;

/* 페이지 썸네일 위에 임베드 위치/크기를 비율 그대로 보여주는 미리보기 */
/* 가림/잠금 페이지에서는 페이지 이미지와 동일하게 블러 처리된다 */
export const EmbedOverlay = styled.div`
  position: absolute;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.zinc_900};
  border-radius: 2px;
  color: ${theme.colors.white};
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.is-blind {
    filter: blur(6px);
  }
`;

export const LockOverlay = styled(Flex)`
  position: absolute;
  background: rgb(79 88 96 / 50%);
  inset: 0;
`;
